import { Ubicacion } from "@/domain/entities/ubicacion";
import { Header } from "@/presentation/components";
import { DataTable, DataTableColumn } from "@/presentation/components/common/DataTable";
import { Detail, DetailSection } from "@/presentation/components/DetailCard/DetailCard";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { BottomAppBar } from "@/presentation/components/layout/BottomAppBar";
import { useAuthContext } from "@/presentation/context";
import { useEquipo } from "@/presentation/hooks/useEquipo";
import { useUbicacion } from "@/presentation/hooks/UseUbicacion";
import { routes } from "@/presentation/router";
import { Categories, formatStateE } from "@/shared";
import { formatSmartDateTime } from "@/shared/utils/dateFormaters";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./DetalleYTabla.css";

export default function UbicacionDetailPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };
  const {
    data: equipos,
    loadAll: getEquipos,
  } = useEquipo();
  
 

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    setIsDrawerOpen(false);
    navigate(routes.login, { replace: true });
  };
  const { id } = useParams();
  console.log('Ubicacion PARAMS', id);

  const {
    data,
    reload,
  } = useUbicacion();
  console.log('Ubicacion cargado:', data);
  useEffect(() => {
    if (!id) {
      return;
    }

    reload(id);
    getEquipos({ ubicacion: Number(id) });
  }, [id, reload, getEquipos]);

  if (!data) {
    return <>Cargando...</>;
  }
  const UbicacionDetailSections: DetailSection<Ubicacion>[] = [
    {
      title: "Información General",
      fields: [
        {
          label: "Ubicación",
          key: "nombre",

        },
        {
          label: "Usuario de Alta",
          key: "usuario",
        },

        {
          label: "Grupo",
          key: "grupo",
        },

        {
          label: "Fecha de Alta",
          key: "fecha",
          render: (value) => formatSmartDateTime(new Date(value as number))
        },
        {
          label: "Categoría",
          key: "cp",
          render: (value) => Categories(Number(value ?? 0))
        }

      ],
    },
    {
      title: "Localización",
      fields: [
        {
          label: "Dirección",
          key: "direccion",
        },
        {
          label: "Barrio",
          key: "barrio",
        },
        {
          label: "Provincia",
          key: "provincia",

        },
        {
          label: 'Observaciones',
          key: 'observaciones'
        }

      ],
    }
  ];
  const columns: DataTableColumn<any>[] = [
    {
      key: 'equipo',
      header: 'Equipo',
    },
    {
      key: 'lote',
      header: 'Lote',
    },
    {
      key: 'tipo',
      header: 'Tipo',
    },
    {
      key: 'estado',
      header: 'Estado',
      render: (value) =>
        formatStateE(value.estado),
    },
  ];

  const handleEdit = () => {
    navigate(`/ubicacion/formulario/${id}`);
  };

  return (
    <div className="detail-page">
      <Header
        title="Detalle de la Ubicación"
        onMenuClick={handleOpenDrawer}
      />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={handleCloseDrawer}
        onLogout={handleLogout}
      />

      <main className="detail-page__content">
        <Detail
          data={data}
          sections={UbicacionDetailSections}
        />

        <section
          className="detail-page__list"
          aria-labelledby="equipos-asociados-title"
        >
          <div className="detail-page__section-header">
            <div>
              <h2 id="equipos-asociados-title">Equipos asociados</h2>
              <p>Equipos registrados actualmente en esta ubicación.</p>
            </div>

            <span className="detail-page__count">
              {equipos.length}
            </span>
          </div>

          <DataTable
            columns={columns}
            data={equipos}
            onRowClick={(equipo) =>
              navigate(`/equipo/${equipo.id}`)
            }
            emptyMessage="No hay equipos cargados"
          />
        </section>
      </main>

      <BottomAppBar
        items={[
          {
            label: "Editar",
            onClick: handleEdit,
            icon: undefined,
          },
        ]}
      />
    </div>
  );
}
